var map = {
	"./account.svg": 1223,
	"./account_badged.svg": 1226,
	"./account_checked.svg": 1227,
	"./alert-circle.svg": 1228,
	"./arrow-left_rounded.svg": 1229,
	"./arrow-left_squared.svg": 1230,
	"./arrow-right_rounded.svg": 1231,
	"./arrow-right_squared.svg": 1232,
	"./arrow-top.svg": 1233,
	"./bank-check.svg": 1234,
	"./bell-checkmark.svg": 1235,
	"./bell-plus.svg": 1236,
	"./bell.svg": 1237,
	"./bookmark.svg": 1238,
	"./bookmark_filled.svg": 1239,
	"./bullet-leaf.svg": 1240,
	"./calendar.svg": 1241,
	"./cart-checkmark.svg": 1242,
	"./cart-clock.svg": 1243,
	"./cart-plus.svg": 1244,
	"./cart.svg": 1245,
	"./cart_added.svg": 1246,
	"./cart_deleted.svg": 1247,
	"./cart_emptied.svg": 1248,
	"./chat.svg": 1249,
	"./checkmark-white.svg": 1250,
	"./checkmark.svg": 1251,
	"./chevron-down.svg": 1252,
	"./chevron-left.svg": 1253,
	"./chevron-right.svg": 1254,
	"./chevron-up.svg": 1255,
	"./clock.svg": 1256,
	"./close.svg": 1257,
	"./copy.svg": 1258,
	"./cost.svg": 1259,
	"./cream.svg": 1260,
	"./credit-card.svg": 1261,
	"./delete.svg": 1262,
	"./delivery.svg": 1263,
	"./download.svg": 1264,
	"./edit.svg": 1265,
	"./erase.svg": 1266,
	"./error-circle.svg": 1267,
	"./file-pdf.svg": 1268,
	"./filter.svg": 1269,
	"./gift.svg": 1270,
	"./heart.svg": 1271,
	"./heart_filled.svg": 1272,
	"./hide.svg": 1273,
	"./history.svg": 1274,
	"./hourglass.svg": 1275,
	"./info-circle.svg": 1276,
	"./invoice.svg": 1277,
	"./link.svg": 1278,
	"./lock.svg": 1279,
	"./log-in.svg": 1280,
	"./log-out.svg": 1281,
	"./menu.svg": 1282,
	"./microscope.svg": 1283,
	"./minus.svg": 1284,
	"./mortar.svg": 1285,
	"./offers.svg": 1286,
	"./package.svg": 1287,
	"./package_returned.svg": 1288,
	"./payment-4x.svg": 1289,
	"./payments.svg": 1290,
	"./place_added.svg": 1291,
	"./play-overlay.svg": 1292,
	"./play.svg": 1293,
	"./plus.svg": 1294,
	"./question-circle.svg": 1295,
	"./rebuy.svg": 1296,
	"./recipe-book.svg": 1297,
	"./search.svg": 1298,
	"./share.svg": 1299,
	"./shop.svg": 1300,
	"./show.svg": 1301,
	"./star.svg": 1302,
	"./star_filled.svg": 1303,
	"./survey-logo.svg": 1304,
	"./time.svg": 1305,
	"./transfer.svg": 1306,
	"./unsub.svg": 1307,
	"./warning.svg": 1308
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1222;